module.exports = __webpack_public_path__ + "img/guincho-24h.95ab6b15.svg";